const { gql } = require('@apollo/client');

export const QUERY_LICENSE = gql`
  query License {
    license {
      checkActivation {
        Activated
        AvailableToTransfer
        LicenseName
        LicenseCode
        LicenseEndTime
        LicenseSupportEndTime
        SessionId
        Message
      }
    }
  }
`;

export const QUERY_AVAILABLE_DAYS = gql`
  query License($licenseCode: String!) {
    license {
      transfer {
        availableDays(LicenseCode: $licenseCode)
      }
    }
  }
`;

export const MUTATION_ACTIVATE_LICENSE = gql`
  mutation License($licenseCode: String!) {
    license {
      activate(LicenseCode: $licenseCode) {
        Activated
        AvailableToTransfer
        LicenseName
        LicenseCode
        LicenseEndTime
        LicenseSupportEndTime
        SessionId
        Message
      }
    }
  }
`;

export const MUTATION_DEACTIVATE_LICENSE = gql`
  mutation License {
    license {
      deactivate {
        Activated
      }
    }
  }
`;

export const MUTATION_TRANSFER_LICENSE = gql`
  mutation License($licenseCode: String!) {
    license {
      transfer(LicenseCode: $licenseCode) {
        Activated
        SessionId
      }
    }
  }
`;
